<template>
  <!-- iOS app: nothing in the drawer — it closes and the form opens as a page (see onMounted) -->
  <div v-if="asPage" class="flex-1 flex items-center justify-center py-8">
    <i class="pi pi-spin pi-spinner text-2xl text-surface-400" />
  </div>
  <PaymePaymentForm
    v-else
    v-bind="$attrs"
    :paymentUuid="paymentUuid"
    :maxInstallments="12"
    :showWallet="false"
    @completed="emit('completed')" />
</template>

<script setup lang="ts">
import { onMounted } from 'vue';
import { useRouter } from 'vue-router';
import { Capacitor } from '@capacitor/core';
import { PaymePaymentForm, useDrawer } from '@torim-app/shared-components';
import { AdminRouteNames } from '@app/router/route-names';

defineOptions({ inheritAttrs: false });

const props = defineProps<{
  paymentUuid: string;
}>();

const emit = defineEmits<{
  (e: 'completed'): void;
}>();

// In the iOS app PayMe's card fields — and anything layered over the open drawers — take no
// touches, so there the charge moves to its own page, with every drawer closed. A route change
// only closes the top drawer, and the sheet may be stacked on the appointment's drawer, hence
// closing twice.
const asPage = Capacitor.getPlatform() === 'ios';
const router = useRouter();
const { closeDrawer } = useDrawer();

onMounted(() => {
  if (!asPage) return;
  closeDrawer();
  closeDrawer();
  router.push({ name: AdminRouteNames.ManualCardCharge, params: { uuid: props.paymentUuid } });
});
</script>
